/**
 * date.js
 * Path: frontend/src/utils/date.js
 * Description: Pomocnicze formatery i przeliczenia dat dla widoku miesięcznego i formularzy.
 * Related: pages/CalendarPage.jsx, components/MonthCalendar.jsx
 */

export function startOfMonth(value = new Date()) {
  const date = new Date(value);
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function endOfMonth(value = new Date()) {
  const date = new Date(value);
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export function toIsoDate(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function toPolishDateTime(value) {
  if (!value) return "brak";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "brak";
  return date.toLocaleString("pl-PL", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function toDateInputValue(value) {
  const date = value ? new Date(value) : new Date();
  const tzOffsetMs = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() - tzOffsetMs).toISOString().slice(0, 16);
}

export function fromDateInputValue(value) {
  return new Date(value).toISOString();
}

export function monthLabel(value) {
  return new Date(value).toLocaleDateString("pl-PL", {
    month: "long",
    year: "numeric",
  });
}

export function isSameDayRange(job, dateIso) {
  const start = new Date(job.startAt || job.start_at || "");
  const end = new Date(job.endAt || job.end_at || "");
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return false;
  const dayStart = new Date(`${dateIso}T00:00:00`);
  const dayEnd = new Date(`${dateIso}T23:59:59`);
  return start <= dayEnd && end >= dayStart;
}
